import getEnv from "./getEnv";
export { default as getEnv } from "./getEnv";
var env = getEnv();
export var appEnv = (env === null || env === void 0 ? void 0 : env.appEnv) || {};
export var platform = env === null || env === void 0 ? void 0 : env.platform;
export var client = env === null || env === void 0 ? void 0 : env.client;
export default appEnv;